var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "mb-2" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            {
              staticClass: "p-1 flex-column flex-sm-row",
              attrs: { "align-v": "center" }
            },
            [
              _c(
                "b-col",
                { staticClass: "col-md-5 col-sm-12 p-1 text-center" },
                [
                  _c("b-card-text", [
                    _c(
                      "h5",
                      { staticClass: "m-0" },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.getContestURL(_vm.contest.alias)
                            }
                          },
                          [_vm._v(_vm._s(_vm.contest.title))]
                        ),
                        _vm.contest.recommended
                          ? _c("font-awesome-icon", {
                              ref: "contestIconRecommended",
                              staticClass: "ml-1 mr-1",
                              attrs: { icon: "award" }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "col-md-3 col-sm-12 p-1 text-center" },
                [
                  _c(
                    "b-card-text",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center"
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "clipboard-list" }
                      }),
                      _c("p", { staticClass: "m-0" }, [
                        _vm._v(_vm._s(_vm.contest.organizer))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "col-md-4 col-sm-12 p-1 text-center" },
                [
                  _vm._t("contest-button-scoreboard", [
                    _c(
                      "b-button",
                      {
                        ref: "contestButtonScoreboard",
                        staticClass:
                          "d-flex justify-content-center align-items-center",
                        attrs: {
                          href: _vm.getContestScoreboardURL(_vm.contest.alias),
                          variant: "success"
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "mr-1",
                          attrs: { icon: "table" }
                        }),
                        _c("p", { staticClass: "m-0" }, [
                          _vm._v(_vm._s(_vm.T.contestButtonScoreboard))
                        ])
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-center"
                    },
                    [
                      _vm._t("contest-enroll-status", [
                        _vm.contest.participating
                          ? _c(
                              "b-card-text",
                              {
                                ref: "contestEnrollStatus",
                                staticClass:
                                  "contest-enroll-status d-flex justify-content-center align-items-center"
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "mr-1",
                                  attrs: { icon: "clipboard-check" }
                                }),
                                _c("p", { staticClass: "m-0" }, [
                                  _vm._v(_vm._s(_vm.T.contestEnrollStatus))
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ],
                    2
                  )
                ],
                2
              )
            ],
            1
          ),
          _c(
            "b-row",
            {
              staticClass: "p-1 flex-column flex-sm-row",
              attrs: { "align-v": "center" }
            },
            [
              _c(
                "b-col",
                { staticClass: "col-md-5 col-sm-12 p-1 text-center" },
                [_vm._t("text-contest-date")],
                2
              ),
              _c(
                "b-col",
                { staticClass: "col-md-3 col-sm-12 p-1 text-center" },
                [
                  _c(
                    "b-card-text",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center"
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "stopwatch" }
                      }),
                      _c("p", { staticClass: "m-0" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.ui.formatString(_vm.T.contestDuration, {
                                duration: _vm.contestDuration
                              })
                            ) +
                            " "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass:
                    "col-md-4 col-sm-12 p-1 text-center d-flex justify-content-center"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-center"
                    },
                    [
                      _vm._t("default", [
                        _c(
                          "b-card-text",
                          {
                            staticClass:
                              "mr-3 m-0 d-flex justify-content-center align-items-center"
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "m-1",
                              attrs: { icon: "users" }
                            }),
                            _c("p", { staticClass: "m-0" }, [
                              _vm._v(_vm._s(_vm.contest.contestants))
                            ])
                          ],
                          1
                        )
                      ]),
                      _vm._t("contest-button-enter", [
                        _vm.contest.participating
                          ? _c(
                              "b-button",
                              {
                                ref: "contestButtonEnter",
                                staticClass:
                                  "button-style d-flex justify-content-center align-items-center",
                                attrs: {
                                  href: _vm.getContestURL(_vm.contest.alias),
                                  variant: "primary"
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "mr-1",
                                  attrs: { icon: "sign-in-alt" }
                                }),
                                _c("p", { staticClass: "m-0" }, [
                                  _vm._v(_vm._s(_vm.T.contestButtonEnter))
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._t("contest-button-see-details", [
                        !_vm.contest.participating
                          ? _c(
                              "b-button",
                              {
                                ref: "contestButtonSeeDetails",
                                staticClass: "text-center",
                                attrs: {
                                  href: _vm.getContestURL(_vm.contest.alias),
                                  variant: "primary"
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass:
                                    "mr-1 d-flex justify-content-center align-items-center",
                                  attrs: { icon: "sign-in-alt" }
                                }),
                                _c("p", { staticClass: "m-0" }, [
                                  _vm._v(_vm._s(_vm.T.contestButtonSeeDetails))
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ],
                    2
                  ),
                  _vm._t("contest-dropdown", [
                    _c(
                      "b-dropdown",
                      {
                        attrs: { variant: "primary" },
                        scopedSlots: _vm._u([
                          {
                            key: "button-content",
                            fn: function() {
                              return [
                                _c("font-awesome-icon", {
                                  staticClass:
                                    "mr-1 d-flex justify-content-center align-items-center",
                                  attrs: { icon: "sign-in-alt" }
                                }),
                                _c("p", { staticClass: "m-0" }, [
                                  _vm._v(_vm._s(_vm.T.contestButtonEnter))
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: {
                              href: _vm.getVirtualContestURL(_vm.contest.alias)
                            }
                          },
                          [_vm._v(_vm._s(_vm.T.contestVirtualMode))]
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: {
                              href: _vm.getPracticeContestURL(_vm.contest.alias)
                            }
                          },
                          [_vm._v(_vm._s(_vm.T.contestPracticeMode))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }